<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    DAFTAR ANTRIAN OBAT APOTEK RAWAT INAP
                </h1>
            </div>
            <div class="w-full md:w-1/2 mt-10 mb-5 mx-auto">
                <DateInput
                    v-model="tglMasukData"
                    class="w-full grow mr-5"
                    id="tgl_masuk"
                    label="PILIH TANGGAL MASUK"
                />
            </div>
            <div class="w-full flex md:w-1/2 mx-auto">
                <button
                    @click.prevent="exportExcel()"
                    class="bg-pink-600 hover:bg-pink-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs mr-2"
                >
                    EXPORT EXCEL
                </button>
                <button
                    @click.prevent="getApotekRanap()"
                    class="bg-green-600 hover:bg-green-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center w-36 h-10 text-xs"
                >
                    CARI
                </button>
            </div>
            <div class="w-full mt-10">
                <!-- <p class="font-sm text-center mt-2">
                    TANGGAL JAM {{ apotekRanapData.tglJam }}
                </p> -->
                <p class="font-sm text-center mt-2">
                    TANGGAL MASUK {{ apotekRanapData.tglMasuk }}
                </p>
                <p class="font-sm text-center mt-2">
                    JUMLAH RESEP YANG MASIH PROSES
                    {{ apotekRanapData.jumlahResepProses }}
                </p>
            </div>
            <div class="w-full my-3">
                <div class="font-poppins mt-2 mb-2 text-right">
                    <p class="font-sm">
                        data diperbaharui pada :
                        <span class="text-red-500">{{ timerCount }}</span>
                    </p>
                </div>
                <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300">
                <table class="w-full whitespace-nowrap">
                    <thead>
                        <tr class="text-left font-bold bg-amber-100">
                            <th class="py-2 px-3 text-center text-sm">No</th>
                            <th class="py-2 px-3 text-center text-sm">
                                Nomor Transaksi
                            </th>
                            <th class="py-2 px-3 text-center text-sm">Jam</th>
                            <th class="py-2 px-3 text-center text-sm">Nama</th>
                            <th class="py-2 px-3 text-center text-sm">Layanan</th>
                            <th class="py-2 px-3 text-center text-sm">Register</th>
                            <th class="py-2 px-3 text-center text-sm">Obat Pulang</th>
                            <th class="py-2 px-3 text-center text-sm">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="apotekRanap in apotekRanapData.resepRacik"
                            class="hover:bg-gray-100"
                        >
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ apotekRanap.no }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ apotekRanap.no_transaksi }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ apotekRanap.jam_transaksi }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ apotekRanap.nama_pasien }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ apotekRanap.layanan }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ apotekRanap.register }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer text-center">
                                {{ apotekRanap.is_resep_pulang==1?"✅":"❌" }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ apotekRanap.status }}
                            </td>
                        </tr>
                        <tr v-if="apotekRanapData.resepRacik.length === 0">
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer" colspan="9">
                                Belum ada data resep racik
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
                <div class="w-full">
                    <p class="font-sm text-center mt-5">
                        DATA ANTRIAN OBAT APOTEK RAWAT INAP STATUS PENYERAHAN
                    </p>
                </div>
                <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300">
                <table class="w-full whitespace-nowrap">
                    <thead>
                        <tr class="text-left font-bold bg-amber-100">
                            <th class="py-2 px-3 text-center text-sm">No</th>
                            <th class="py-2 px-3 text-center text-sm">
                                Nomor Transaksi
                            </th>
                            <th class="py-2 px-3 text-center text-sm">Jam</th>
                            <th class="py-2 px-3 text-center text-sm">Nama</th>
                            <th class="py-2 px-3 text-center text-sm">Layanan</th>
                            <th class="py-2 px-3 text-center text-sm">Register</th>
                            <th class="py-2 px-3 text-center text-sm">Obat Pulang</th>
                            <th class="py-2 px-3 text-center text-sm">Status</th>
                            <th class="py-2 px-3 text-center text-sm">Jam Penyerahan</th>
                            <th class="py-2 px-3 text-center text-sm">
                                Waktu Tunggu
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="apotekRanap in apotekRanapData.serah"
                            class="hover:bg-gray-100"
                        >
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ apotekRanap.no }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ apotekRanap.no_transaksi }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ apotekRanap.jam_transaksi }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ apotekRanap.nama_pasien }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ apotekRanap.layanan }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ apotekRanap.register }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer text-center">
                                {{ apotekRanap.is_resep_pulang==1?"✅":"❌" }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                SERAHKAN
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"> {{ apotekRanap.jam_serah }}</td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">{{ apotekRanap.waktu_tunggu }}</td>
                        </tr>
                        <tr class="bg-white hover:bg-gray-100 focus-within:bg-gray-100" v-if="apotekRanapData.serah.length === 0">
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer" colspan="9">
                                Belum ada data serah
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdmin from "../../../Shared/LayoutAdmin.vue";
import LayoutAdminBig from "../../../Shared/LayoutAdminBig.vue";
import RandomShape from "../../../Shared/RandomShape.vue";
import DateInput from "../../../Shared/DateInput.vue";
import TextInput from "../../../Shared/TextInput.vue";
export default {
    components: {
        Link,
        RandomShape,
        DateInput,
        TextInput,
    },
    data() {
        return {
            tglMasukData: this.tglMasuk,
            tglJamData: this.tglJam,
            apotekRanapData: this.apotekRanap,
            timerCount: 10,
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                } else {
                    this.getApotekRanap();
                }
            },
            immediate: true,
        },
    },
    props: {
        apotekRanap: Object,
        tglMasuk: String,
    },
    methods: {
        getApotekRanap() {
            this.$inertia.get(
                "/admin/apotek_ranap/ajax",
                {
                    tglMasuk: this.tglMasukData,
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.timerCount = 10;
                        this.apotekRanapData =
                            page.props.additional.apotekRanap;
                    },
                }
            );
        },
        exportExcel(){
            location.href = '/admin/apotek_ranap/export/excel?tglMasuk='+this.tglMasukData;
        }
    },
    layout: LayoutAdminBig,
};
</script>
